export default {
  transaction: {
    title: '거래 내역',
    select: '선택',
    all: '전체',
    loading: '로딩 중...',
    noMoreData: '더 이상 데이터가 없습니다',
    mockSuccess: '모의 성공',
    mockFail: '모의 실패',
    mockSuccessDone: '모의 성공 완료',
    mockFailDone: '모의 실패 완료',
    mockFailed: '모의 실패',
    today: '오늘',
    yesterday: '어제',
    last3Days: '최근 3일',
    last7Days: '최근 7일',
    last15Days: '최근 15일',
    last30Days: '최근 30일',
    allTypes: '모든 유형',
    deposit: '입금',
    withdrawal: '출금',
    withdrawalRefund: '출금 환불',
    bet: '베팅',
    win: '당첨',
    manualAdd: '수동 추가',
    manualSubtract: '수동 차감',
    commission: '커미션',
    bonus: '보너스',
    vipUpgradeReward: 'VIP 승급 보상',
    vipSalary: 'VIP 급여',
    gameOutPrincipal: '게임 출금 - 원금',
    gameOutBonus: '게임 출금 - 보너스',
    bonusTransferOut: '보너스 이체 출금',
    allStats: '모든 상태',
    underReview: '검토 중',
    pendingPayout: '출금 대기',
    successful: '성공',
    failed: '실패',
    cancelled: '취소됨',
    processing: '처리 중',
  },
};
